'use client';
import React, { ReactNode } from 'react';
import { useUserStore } from '@stores/user';
import { Navigate } from 'react-router-dom';
import { useClientStore } from '@/client/stores/client';

interface LayoutProps {
  children: ReactNode;
  onAllow?: () => void;
}

const LoadingSpinner: React.FC = () => (
  <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-gray-900" />
);

const LoadingFallback = () => (
  <div className="flex min-h-screen flex-col items-center justify-center">
    <LoadingSpinner />
    <p className="mt-4 font-medium text-gray-600">Checking session...</p>
  </div>
);

/** Session gate only. Per-route permissions are RequirePermission's job.
 *  Logging out here on `admin !== 1` bounced signed-in staff: users/info may
 *  omit that flag or return it as true/"1", and Strict Mode fired logout twice. */
const RestrictedPage: React.FC<LayoutProps> = ({ children }) => {
  const { isLoadingUser, user, initialized } = useUserStore();
  const { initialized: initializedClient } = useClientStore();

  if (isLoadingUser || !initialized || !initializedClient) {
    return <LoadingFallback />;
  }

  if (!user) return <Navigate to="/" replace />;

  return <>{children}</>;
};

export default RestrictedPage;
